import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MessageService } from 'src/services/message.service';
import { NotificationsService } from "../../../services/notifications.service";
@Component({
  selector: 'rm-edit-segment-dialog',
  templateUrl: './edit-segment-dialog.component.html',
  styleUrls: ['./edit-segment-dialog.component.css']
})
export class EditSegmentDialogComponent implements OnInit {

  public segmentForm: FormGroup;
  segmentEdited: boolean = false;
  constructor(
    private notificationService: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private msgService: MessageService,
    private dialogRef: MatDialogRef<EditSegmentDialogComponent>,
  ) { }


  ngOnInit() {
    this.segmentForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()
    });

    if (this.data.rec) {
      this.segmentForm.patchValue({
        name: this.data.rec.name,
        description: this.data.rec.description
      });
    }
  }

  onNameChange(event) {
    if (event.target.value) {
      this.segmentEdited = true;
    }
  }

  onDescriptionChange(event) {
    if (event.target.value) {
      this.segmentEdited = true;
    }
  }

  editSegment(val) {
    this.notificationService.updateSegments(this.data.rec.id, val).subscribe(
      res => {
        this.dialogRef.close('updated');
        this.msgService.showSuccess(this.msgService.segmentUpdate);
      }, err => {

      });
  }

  cancel() {
    this.dialogRef.close();
  }

}